import { useReframe } from 'nike-re-framejs';
import React, { forwardRef } from 'react';
import { Iterable, List } from 'immutable';
import i18n from '@i18n';
import { Button } from 'nike-ui/src/components/button/Button';
import { isPendingValidation, isFormTouched, isTouched } from 'nike-form-js';

function getAllErrorsPaths(value, res, path) {
    if (value instanceof Iterable) {
        value.entrySeq().forEach(([key, val]) => getAllErrorsPaths(val, res, path.concat(key)));
    } else if (value.errors && value.errors.size > 0) {
        res.push(List(path));
    }
    return res;
}

export function hasVisibleError(form$) {
    return form$.map(form => {
        const allErrors = getAllErrorsPaths(form.get('validatorError'), [], []),
            touchedFields = form.get('touchedFields'),
            forcedValidation = form.get('forcedValidation');

        return allErrors.some(val => touchedFields.get(val) === true) || (forcedValidation && allErrors.length > 0);
    });
}

export const Submit = forwardRef(function(
    {
        form,
        showError = true,
        disabled = false,
        enabledOnStart = false,
        label,
        hint,
        forceEnabled = false,
        className,
        onClick
    },
    ref
) {
    const { deref } = useReframe();
    const hasVisibleErrors = deref(hasVisibleError(form));
    const isFormTouchedSubmit = deref(isFormTouched(form));
    const isTouchedSubmit = deref(isTouched(form));
    const isPending = deref(isPendingValidation(form));
    const shouldBeDisabled =
        (disabled || !(isFormTouchedSubmit || enabledOnStart) || hasVisibleErrors || isPending) && !forceEnabled;
    return (
        <div className="nike-input">
            {showError && hasVisibleErrors && isTouchedSubmit ? (
                <div className="nike-input-error error-above">{i18n('commons.button.formHasErrors')}</div>
            ) : null}
            <Button
                primary
                className={className}
                onClick={onClick}
                disabled={shouldBeDisabled}
                type="submit"
                label={label || i18n('commons.button.odoslat')}
                ref={ref}
            />
            {hint ? <div className="nike-input-hint">{hint}</div> : null}
        </div>
    );
});
